import { CANADIAN_PROVENCES, US_STATES } from 'vopay';

/**
 * The code for a province or state the API names in English (`/partner/extended-info` resolves
 * `ADRProvinces_ID` to `ADRProvince->Province`, e.g. "British Columbia" → "BC"). The code is what
 * the design shows in an address line and reads the same in both locales, which the English name
 * does not; a name the library's lists do not carry renders as sent.
 */
export default function toProvinceCode(provinceName: string): string {
  const match = Object.entries({ ...CANADIAN_PROVENCES, ...US_STATES }).find(([, name]) => name === provinceName);

  return match ? match[0] : provinceName;
}
